import { useParams } from 'react-router-dom'
import EditQuestionSetForm from './EditQuestionSetForm'

import { useGetQuestionSetsQuery } from './questionSetsApiSlice'

import PulseLoader from 'react-spinners/PulseLoader'
import useTitle from '../../hooks/useTitle'
import { useGetCoursesQuery } from '../courses/coursesApiSlice'
const EditQuestionSet = () => {
    useTitle('geshtop-Exercise: Edit QuestionSet')

    const { questionSetId } = useParams()


    const { questionSet } = useGetQuestionSetsQuery("questionSetsList", {
        selectFromResult: ({ data }) => ({
            questionSet: data?.entities[questionSetId]
        }),
    })

    const { courses } = useGetCoursesQuery("coursesList", {
        selectFromResult: ({ data }) => ({
            courses: data?.ids.map(id => data?.entities[id])
        }),
    })

    if (!questionSet || !courses) return <PulseLoader color={"#FFF"} />



    const content =
    <>
    <EditQuestionSetForm questionSet={questionSet} courses={courses} />  
       
    </>

    return content
}
export default EditQuestionSet